import { connect } from 'react-redux';
import FamilyAccess from './FamilyAccess';
import { selectUserData, selectUserLoading } from 'modules/App/utils/selectors';
import { getRelations } from 'modules/Profile/redux/relations/actions';
import {
  selectUserRelationsList,
  selectUserRelationsListLoading,
} from 'modules/Profile/redux/relations/selectors';
import { getInfo as getUserInfo } from 'modules/App/redux/user/actions';

const mapStateToProps = (state) => ({
  user: selectUserData(state),
  relations: selectUserRelationsList(state),
  isLoading: selectUserRelationsListLoading(state) || selectUserLoading(state),
});

const mapDispatchToProps = {
  getRelations,
  getUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(FamilyAccess);
